import { Alert, AlertDescription, AlertIcon, VStack } from '@chakra-ui/react';
import Card from 'components/card/Card';

const StandardSubmissionWarning = () => {
  return (
    <Card>
      <VStack spacing={6} align="stretch">
        <Alert status="warning" borderRadius="md">
          <AlertIcon />
          <AlertDescription>
            <strong>This policy appears to be a standard submission.</strong>
            <br />
            Please restart the submission without selecting the Specialty
            Submission option.
          </AlertDescription>
        </Alert>
      </VStack>
    </Card>
  );
};

export default StandardSubmissionWarning;
